import React from 'react';
import { usePathContext } from '../../context/PathContext.js';
import styles from './styles.css.js';

var ProgressBar = function ProgressBar() {
  var _a;

  var pathContext = usePathContext();
  /**
   * If the estimated precent completed was incalculable, this value could return null. It won't
   * be a common enough case that it's worth having a fallback, so just hide the progress bar
   * entirely.
   */

  var estimatedPercentCompleted = (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.estimatedPercentCompleted;

  if (!estimatedPercentCompleted) {
    return null;
  }

  return React.createElement("div", {
    className: styles.progressBar
  }, React.createElement("div", {
    className: styles.progressFill,
    style: {
      width: "".concat(estimatedPercentCompleted, "%")
    }
  }));
};

export default ProgressBar;
//# sourceMappingURL=index.js.map
